



































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import WorkshopsBookingDetails from "../workshops/WorkshopsBookingDetails.vue";

import { WorkshopWithBookingJson } from "../../shared/WorkshopJson";
import { WorkshopBookingStatus } from "../../shared/WorkshopBookingStatus";
import PaymentExportInfoJson from "../../shared/PaymentExportInfoJson";
import { PaymentExportType } from "../../shared/PaymentExportType";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";

export default Vue.extend({
  name: "WorkshopsPayments",
  components: {
    Loading,
    WorkshopsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
    WorkshopsBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      WorkshopBookingStatus: WorkshopBookingStatus,
      paymentExportWorkshops: null as WorkshopWithBookingJson[] | null,
      exportedWorkshops: null as PaymentExportInfoJson[] | null,
      selectedWorkshopProgramId: null as number | null,
      selectedWorkshopBookingId: null as number | null,
      detailsMode: "read",
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    openDetails(item: WorkshopWithBookingJson | null, mode: string) {
      if (item != null) {
        this.selectedWorkshopProgramId = item.ID;
        this.selectedWorkshopBookingId = item.booking.ID;

        this.detailsMode = mode;
        this.toggleDetails();
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadWorkshopsToExport();
      this.loadExportedWorkshops();
    },

    async loadWorkshopsToExport() {
      this.paymentExportWorkshops = null;
      if (this.restClient != null) {
        try {
          this.paymentExportWorkshops = await this.restClient.getWorkshopBookingsReadyForPaymentExport();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadExportedWorkshops() {
      this.exportedWorkshops = null;
      if (this.restClient != null) {
        try {
          this.exportedWorkshops = await this.restClient.getRecentPaymentExports(PaymentExportType.workshopBookings);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //export payment data
    async exportPaymentData() {
      this.isExporting = true;

      try {
        var exportInfo = await this.restClient.exportPaymentsForWorkshopBookings();
        if (exportInfo != null) {
          this.downloadPaymentData(exportInfo);
        } else {
          this.isExporting = false;
          alert("Aktuell sind keine Zahlungsdaten zum Export bereit.");
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    async downloadPaymentData(downloadInfo: PaymentExportInfoJson) {
      this.isExporting = true;

      try {
        var data = await this.restClient.downloadPaymentExportFile(downloadInfo);
        if (data != null) {
          let atag = document.createElement("a");
          atag.style.display = "none";
          document.body.appendChild(atag);

          let blob = new Blob([data], { type: "octet/stream" });
          let url = window.URL.createObjectURL(blob);

          atag.href = url;
          atag.download = "payment_" + DateFormatter.formatFilenameDateTime(new Date(downloadInfo.dateTime)) + ".zip";
          atag.click();
          window.URL.revokeObjectURL(url);

          this.isExporting = false;
          this.loadData();
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {},
});
